import React, { useEffect } from "react"
import { Pagination, PaginationItem, PaginationLink } from "reactstrap"

const PaginationComponent = ({
  pagesCount,
  currentPage,
  setCurrentPage,
  params,
}) => {
  currentPage += 1
  const isCurrentPageFirst = currentPage === 1
  const isCurrentPageLast = currentPage === pagesCount

  const changePage = number => {
    if (currentPage === number) return
    setCurrentPage({
      ...params,
      page: number - 1,
    })
  }
  const onPageNumberClick = pageNumber => {
    changePage(pageNumber)
  }
  const onPreviousPageClick = () => {
    changePage(1)
  }
  const onNextPageClick = () => {
    changePage(pagesCount)
  }

  const setLastPageAsCurrent = () => {
    if (currentPage > pagesCount && pagesCount !== 0) {
      setCurrentPage({
        ...params,
        page: pagesCount - 1,
      })
    }
  }

  let isPageNumberOutOfRange

  const pageNumbers = [...new Array(pagesCount)].map((_, index) => {
    const pageNumber = index + 1
    const isPageNumberFirst = pageNumber === index
    const isPageNumberLast = pageNumber === pagesCount
    const isCurrentPageWithinTwoPageNumbers =
      Math.abs(pageNumber - currentPage) <= 2

    if (
      isPageNumberFirst ||
      isPageNumberLast ||
      isCurrentPageWithinTwoPageNumbers
    ) {
      isPageNumberOutOfRange = false
      return (
        <PaginationItem
          key={pageNumber}
          onClick={() => onPageNumberClick(pageNumber)}
          active={pageNumber === currentPage}
        >
          <PaginationLink>{pageNumber}</PaginationLink>
        </PaginationItem>
      )
    }

    if (!isPageNumberOutOfRange) {
      isPageNumberOutOfRange = true
      return (
        <PaginationItem key={pageNumber}>
          <PaginationLink>...</PaginationLink>
        </PaginationItem>
      )
    }

    return null
  })

  useEffect(setLastPageAsCurrent, [pagesCount])

  return (
    <>
      <Pagination>
        {currentPage !== 1 && (
          <PaginationLink
            previous
            onClick={onPreviousPageClick}
            disabled={isCurrentPageFirst}
          />
        )}

        {pageNumbers}
        {pagesCount > 1 && (
          <PaginationLink
            next
            onClick={onNextPageClick}
            disabled={isCurrentPageLast}
          />
        )}
      </Pagination>
    </>
  )
}

export default PaginationComponent
